
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 152 40","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M120 16h-16V0h-8v16h8v8h-8v16h8V24h24v16h8V16h-8zM128 0h8v8h-8zM32 0v8h-8v8h8v24h8V0zM8 0H0v40h8V16h8V8H8zM16 16h8v8h-8z"}}),_c('g',[_c('path',{staticClass:"st0",attrs:{"d":"M72 16H56v8h24v-8zM64 32h-8v8h24v-8h-8zM80 24h8v8h-8zM48 8h8v8h-8zM72 8h8V0H56v8h8z"}})])])
          )
        }
      }
    